import { CSSProperties } from 'react';
import clsx from 'clsx';
import { IconChevronDown } from '@rossum/ui/icons/tabler';
import { Box, SvgIcon } from '@rossum/ui/material';
import styles from '../style.module.sass';

type Props = {
  value?: string;
  inFooter: boolean;
  style: CSSProperties | undefined;
};

const FakeSelect = ({ value, inFooter, style }: Props) => (
  <Box
    sx={{ fontFeatureSettings: '"zero"' }}
    className={clsx(
      styles['FakeSelect'],
      inFooter && styles['FakeSelectInFooter']
    )}
    style={style}
  >
    <span className={styles['Value']}>{value}</span>
    <SvgIcon fontSize="medium" color="disabled">
      <IconChevronDown />
    </SvgIcon>
  </Box>
);

export default FakeSelect;
